// Shared formatter for the snake_case tag values used across the directory
// (identity, modalities, specialties, insurance, languages, pronouns, etc.).
// Goal: never show a raw underscore_value to the user.

const ACRONYMS = new Set([
  'lgbtq', 'lgbtqia', 'bipoc', 'aapi', 'asl',
  'cbt', 'dbt', 'act', 'eft', 'erp', 'ifs', 'emdr', 'sfbt',
  'ocd', 'ptsd', 'cptsd', 'adhd', 'kap',
  'lcsw', 'lpcc', 'lcpc', 'lmft', 'lmhc', 'llp', 'lmhc-pc',
  'np', 'phd', 'psyd', 'md', 'csp',
  'tricare', 'eap',
  'oice',
]);

const SPECIAL_CASES = {
  // pronouns
  'she_her': 'she/her',
  'he_him': 'he/him',
  'they_them': 'they/them',
  'she_they': 'she/they',
  'he_they': 'he/they',
  'ask_me': 'ask me',
  // common multi-word labels we want to render nicely
  'prefer_not_to_specify': 'Prefer not to specify',
  'cash_self_pay': 'Cash / Self-pay',
  'sliding_scale': 'Sliding scale',
  'sliding_scale_available': 'Sliding scale available',
  'out_of_network_will_provide_superbill': 'Out of network (superbill provided)',
  'insurance_only': 'Insurance only',
  'other_please_specify': 'Other',
  'other_please_elaborate': 'Other',
  '100_or_less': '$100 or less per session',
  '101_150_per_session': '$101–150 per session',
  '151_200_per_session': '$151–200 per session',
  '201_per_session': '$201+ per session',
  'in_person': 'In-person',
  'telehealth': 'Telehealth',
  'weekday_mornings': 'Weekday mornings',
  'weekday_afternoons': 'Weekday afternoons',
  'weekdays_evening': 'Weekday evenings',
  'saturdays': 'Saturdays',
  'sundays': 'Sundays',
};

function titleCaseWord(word) {
  if (!word) return '';
  const lower = word.toLowerCase();
  if (ACRONYMS.has(lower)) return lower.toUpperCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

// Format a single snake_case value into a human-readable label.
export function formatLabel(value) {
  if (value === null || value === undefined) return '';
  const str = String(value).trim();
  if (!str) return '';
  const key = str.toLowerCase();
  if (SPECIAL_CASES[key]) return SPECIAL_CASES[key];
  return str.split('_').map(titleCaseWord).join(' ');
}

// Format a list (array OR JSON-encoded string OR plain string) into a
// human-readable comma-separated string.
export function formatList(value, separator = ', ') {
  if (value === null || value === undefined) return '';
  let arr = value;
  if (typeof arr === 'string') {
    const trimmed = arr.trim();
    if (trimmed.startsWith('[')) {
      try { arr = JSON.parse(trimmed); } catch (e) { arr = [trimmed]; }
    } else if (!trimmed) {
      return '';
    } else {
      arr = trimmed.split(',').map(s => s.trim()).filter(Boolean);
    }
  }
  if (!Array.isArray(arr)) return formatLabel(arr);
  return arr.map(formatLabel).filter(Boolean).join(separator);
}
